import { css } from 'lit';
export default css ` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #HEADING
\*------------------------------------ */
.cat-c-heading-wrapper {
  display: flex;
}

.cat-c-heading__before {
  margin-inline-end: calc(var(--size-base-unit) * 2.5);
}

/**
 * Heading component
 */
.cat-c-heading {
  margin: var(--cat-heading-margin, 0);
  color: var(--cat-heading-color-content, var(--cat-theme-color-content-strong));
}
.cat-c-heading.cat-c-heading--disabled {
  color: var(--cat-theme-color-content-disabled);
}

/**
 * Heading with theme display xl text
 */
.cat-c-heading--display-xl {
  font-family: var(--cat-theme-typography-display-xl-font-family);
  font-weight: var(--cat-theme-typography-display-xl-font-weight);
  font-size: var(--cat-theme-typography-display-xl-font-size);
  line-height: var(--cat-theme-typography-display-xl-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--display-xl {
    font-size: var(--cat-theme-typography-display-xl-mobile-font-size);
    line-height: var(--cat-theme-typography-display-xl-mobile-line-height);
  }
}

/**
 * Heading with theme heading 1 preset applied
 */
.cat-c-heading--display-lg {
  font-family: var(--cat-theme-typography-display-lg-font-family);
  font-weight: var(--cat-theme-typography-display-lg-font-weight);
  font-size: var(--cat-theme-typography-display-lg-font-size);
  line-height: var(--cat-theme-typography-display-lg-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--display-lg {
    font-size: var(--cat-theme-typography-display-lg-mobile-font-size);
    line-height: var(--cat-theme-typography-display-lg-mobile-line-height);
  }
}

/**
 * Heading with theme heading 2 preset applied
 */
.cat-c-heading--display {
  font-family: var(--cat-theme-typography-display-font-family);
  font-weight: var(--cat-theme-typography-display-font-weight);
  font-size: var(--cat-theme-typography-display-font-size);
  line-height: var(--cat-theme-typography-display-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--display {
    font-size: var(--cat-theme-typography-display-mobile-font-size);
    line-height: var(--cat-theme-typography-display-mobile-line-height);
  }
}

/**
 * Heading with theme display small text
 */
.cat-c-heading--display-sm {
  font-family: var(--cat-theme-typography-display-sm-font-family);
  font-weight: var(--cat-theme-typography-display-sm-font-weight);
  font-size: var(--cat-theme-typography-display-sm-font-size);
  line-height: var(--cat-theme-typography-display-sm-line-height);
}

/**
 * Heading with theme heading 3 preset applied
 */
.cat-c-heading--headline-lg {
  font-family: var(--cat-theme-typography-headline-lg-font-family);
  font-weight: var(--cat-theme-typography-headline-lg-font-weight);
  font-size: var(--cat-theme-typography-headline-lg-font-size);
  line-height: var(--cat-theme-typography-headline-lg-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--headline-lg {
    font-size: var(--cat-theme-typography-headline-lg-mobile-font-size);
    line-height: var(--cat-theme-typography-headline-lg-mobile-line-height);
  }
}

/**
 * Heading with theme heading 4 preset applied
 */
.cat-c-heading--headline {
  font-family: var(--cat-theme-typography-headline-font-family);
  font-weight: var(--cat-theme-typography-headline-font-weight);
  font-size: var(--cat-theme-typography-headline-font-size);
  line-height: var(--cat-theme-typography-headline-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--headline {
    font-size: var(--cat-theme-typography-headline-mobile-font-size);
    line-height: var(--cat-theme-typography-headline-mobile-line-height);
  }
}

/**
 * Heading with theme heading 5 preset applied
 */
.cat-c-heading--title {
  font-family: var(--cat-theme-typography-title-font-family);
  font-weight: var(--cat-theme-typography-title-font-weight);
  font-size: var(--cat-theme-typography-title-font-size);
  line-height: var(--cat-theme-typography-title-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--title {
    font-size: var(--cat-theme-typography-title-mobile-font-size);
    line-height: var(--cat-theme-typography-title-mobile-line-height);
  }
}

/**
 * Heading with theme heading 6 preset applied
 */
.cat-c-heading--title-sm {
  font-family: var(--cat-theme-typography-title-sm-font-family);
  font-weight: var(--cat-theme-typography-title-sm-font-weight);
  font-size: var(--cat-theme-typography-title-sm-font-size);
  line-height: var(--cat-theme-typography-title-sm-line-height);
}

/**
 * Heading with theme label large text
 */
.cat-c-heading--label-lg {
  font-family: var(--cat-theme-typography-label-lg-font-family);
  font-weight: var(--cat-theme-typography-label-lg-font-weight);
  font-size: var(--cat-theme-typography-label-lg-font-size);
  line-height: var(--cat-theme-typography-label-lg-line-height);
  color: var(--cat-theme-color-content-default);
}

/**
 * Heading with theme label text
 */
.cat-c-heading--label {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  color: var(--cat-theme-color-content-default);
}

/**
 * Heading with theme label small text
 */
.cat-c-heading--label-sm {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  color: var(--cat-theme-color-content-default);
}

/**
 * Heading with theme body text small
 */
.cat-c-heading--body {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  color: var(--cat-theme-color-content-default);
}

/**
 * Heading with theme body text small
 */
.cat-c-heading--body-sm {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  color: var(--cat-theme-color-content-default);
}

/**
 * Heading with theme footnote text small
 */
.cat-c-heading--footnote {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  color: var(--cat-theme-color-content-default);
}

/**
 * Heading with theme footnote text small
 */
.cat-c-heading--footnote-bold {
  font-family: var(--cat-theme-typography-footnote-bold-font-family);
  font-weight: var(--cat-theme-typography-footnote-bold-font-weight);
  font-size: var(--cat-theme-typography-footnote-bold-font-size);
  line-height: var(--cat-theme-typography-footnote-bold-line-height);
  color: var(--cat-theme-color-content-default);
}

/**
 * Heading with small yellow underline
 */
.cat-c-heading--decorator {
  position: relative;
}
.cat-c-heading--decorator:after {
  position: absolute;
  content: "";
  display: block;
  background: var(--cat-theme-color-background-brand);
  width: calc(var(--size-base-unit) * 3);
  height: calc(var(--size-base-unit) * 0.5);
  inset-block-end: 0;
  inset-inline-start: 0;
}

/**
 * Heading displau xl decorator
 */
.cat-c-heading--display-xl.cat-c-heading--decorator:after {
  height: calc(var(--size-base-unit) * 1);
  width: calc(var(--size-base-unit) * 16);
  inset-block-end: calc(var(--cat-space-medium) * -1);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--display-xl.cat-c-heading--decorator:after {
    width: calc(var(--size-base-unit) * 10);
  }
}

/**
 * Heading display lg decorator 
 */
.cat-c-heading--display-lg.cat-c-heading--decorator:after {
  height: calc(var(--size-base-unit) * 0.75);
  width: calc(var(--size-base-unit) * 12);
  inset-block-end: calc(var(--cat-space-small) * -1);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--display-lg.cat-c-heading--decorator:after {
    width: calc(var(--size-base-unit) * 8);
  }
}

/**
 * Heading display decorator
 */
.cat-c-heading--display.cat-c-heading--decorator:after {
  height: calc(var(--size-base-unit) * 0.75);
  width: calc(var(--size-base-unit) * 12);
  inset-block-end: calc(var(--cat-space-small) * -1);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--display.cat-c-heading--decorator:after {
    width: calc(var(--size-base-unit) * 8);
  }
}

/**
 * Display sm heading decorator
 */
.cat-c-heading--display-sm.cat-c-heading--decorator:after {
  width: calc(var(--size-base-unit) * 3);
  inset-block-end: calc(var(--cat-space-x-small) * -1);
}

/**
 * Headline lg decorator 
 */
.cat-c-heading--headline-lg.cat-c-heading--decorator:after {
  width: calc(var(--size-base-unit) * 7);
  inset-block-end: calc(var(--cat-space-x-small) * -1);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--headline-lg.cat-c-heading--decorator:after {
    width: calc(var(--size-base-unit) * 6);
  }
}

/**
 * Headline heading decorator
 */
.cat-c-heading--headline.cat-c-heading--decorator:after {
  width: calc(var(--size-base-unit) * 7);
  inset-block-end: calc(var(--cat-space-x-small) * -1);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-heading--headline.cat-c-heading--decorator:after {
    width: calc(var(--size-base-unit) * 5);
  }
}

/**
 * Title heading decorator width
 */
.cat-c-heading--title.cat-c-heading--decorator:after {
  width: calc(var(--size-base-unit) * 4);
  inset-block-end: calc(var(--cat-space-x-small) * -1);
}

/**
 * Title sm heading decorator width 
 */
.cat-c-heading--title-sm.cat-c-heading--decorator:after {
  width: calc(var(--size-base-unit) * 4);
  inset-block-end: calc(var(--cat-space-x-small) * -1);
}

/**
 * Heading component with knockout color variant
 * 1) Sets the color to knockout token
 */
.cat-c-heading--knockout {
  color: var(--cat-theme-color-content-knockout); /* 1 */
}

/**
 * Heading component with knockout brand color variant
 * 1) Sets the color to knockout-brand token
 */
.cat-c-heading--knockout-brand {
  color: var(--cat-theme-color-content-knockout-brand);
}

/**
 * Heading component with error color variant
 * 1) Sets the color to utility-error token
 */
.cat-c-heading--error {
  color: var(--cat-theme-color-content-utility-error);
}

.cat-c-heading--not-has-before {
  display: none;
}
`;
